import Model from 'flarum/common/Model';
export default class TicketReply extends Model {
  message = Model.attribute('message');
  /** The message rendered as HTML by the server-side formatter. */
  messageHtml = Model.attribute('messageHtml');
  attachment = Model.attribute('attachment');
  isStaff = Model.attribute('isStaff');
  createdAt = Model.attribute('createdAt', Model.transformDate);
  user = Model.hasOne('user');
  ticket = Model.hasOne('ticket');
}
flarum.reg.add('cengizkemec-support-tickets', 'common/models/TicketReply', TicketReply);